//  get customer draft order data
let uniquedraftid = [...new Set(customerOrderQuoteId)];
let cid = document.querySelector(".block_main_account-section")?.getAttribute('data-customerid');

fetch('https://dtfrvnbitwxyk.cloudfront.net/draftorderlist_by_customerid.php', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: new URLSearchParams({
        customerid: cid
    })
})
    .then(response => response.json())
    .then(data => {
        data.message.forEach(function (order, index) {
            if (uniquedraftid.includes(order.name)) {
                QuoteorderData(order, index);
            } else {
                if (order.days) {
                    const today = new Date().toISOString().split('T')[0];
                    const start = new Date(order.days);
                    const daysDiff = Math.ceil((new Date(today) - start) / (1000 * 60 * 60 * 24));
                    let quotetags = order.tags;
                    quotetags = quotetags.replace(/Issued|Open|Submitted|Unissued|Accepted|issued|open|submitted|unissued|accepted/g, '').trim();
                    quotetags = quotetags.replace(/,\s*,/g, ', ').replace(/^\s*,|,\s*$/g, '').trim();
                    quotetags = quotetags + ", Closed";

                    if (daysDiff >= 90) {
                        let draftOrderid = order.id;

                        fetch('https://dtfrvnbitwxyk.cloudfront.net/delete_draft_order.php', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: new URLSearchParams({
                                draft_order_id: draftOrderid,
                                newtag: quotetags
                            })
                        })
                            .then(response => response.text())
                            .then(response => {
                            })
                            .catch(error => {
                            });

                    } else { }
                } else { }

                let current_drafttag = order.tags;
                if (current_drafttag.indexOf('Void') != -1 || current_drafttag.indexOf('void') != -1) {
                } else {
                    QuoteorderData(order, index);
                }
            }
        });
    })
    .catch((error) => {
        let emptyContent = document.querySelector('.block__quote__emptycontent');
        if (emptyContent) emptyContent.remove();

        document.querySelector('.quote-content-loader .loading__spinner')?.classList.add('hidden');

        let container = document.querySelector('.main_account_quotetab-content');
        if (container) {
            container.insertAdjacentHTML('afterbegin', `
            <div class="block__quote__emptycontent">
                <h2 class="empty-quote block__content-heading block__tabcontent-heading">Quote is empty.</h2>
                <div class="block__quoteempty-btn">
                    <a href="/collections/all" class="custom_btn black_btn">Continue Shopping</a>
                </div>
            </div>
        `);
        }
    });

function QuoteorderData(order, index) {
    let ordersHtml = '';
    let orderdate = new Date(order.created_at);
    let order_tag = order.tags;

    let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let month = monthNames[orderdate.getMonth()];
    let day = orderdate.getDate();
    let year = orderdate.getFullYear();

    let formattedDate = month + " " + (day < 10 ? '0' + day : day) + ", " + year;
    let quote_daysDiff = 0;
    let quote_activetoday = new Date().toISOString().split('T')[0];
    let quote_activestart = new Date(order.days);

    if (order.days) {
        quote_daysDiff = Math.ceil((new Date(quote_activetoday) - quote_activestart) / (1000 * 60 * 60 * 24));
    } else { }

    // price convertor
    function getEuros(priceconvert) {
        try {
            if (typeof Currency !== 'undefined' && Currency.convert) {
                return Currency.convert(priceconvert, 'USD', currency_code).toFixed(2);
            } else {
                return parseFloat(priceconvert).toFixed(2);
            }
        } catch (e) {
            return parseFloat(priceconvert).toFixed(2);
        }
    }

    let main_first_quoteindex = '';
    let order_invoicefile = '';

    if (index == 0) {
        main_first_quoteindex = 'is-open';
    }

    if (
        order_tag.indexOf('Issued') != -1 || order_tag.indexOf('issued') != -1 ||
        order_tag.indexOf('Accepted') != -1 || order_tag.indexOf('accepted') != -1 ||
        order_tag.indexOf('completed') != -1 ||
        order_tag.indexOf('Open') != -1 || order_tag.indexOf('open') != -1
    ) {
        if (order.total_price <= 0) {
            ordersHtml += '<div class="main_account_quotehistory ' + main_first_quoteindex + '" style="display:none;">';
        } else {
            ordersHtml += '<div class="main_account_quotehistory ' + main_first_quoteindex + '">';
        }
    } else {
        ordersHtml += '<div class="main_account_quotehistory ' + main_first_quoteindex + '">';
    }

    ordersHtml += '<div class="main_account_quotecontent-head">';
    ordersHtml += '<div class="main_account-lefthead-quotecontent main_account_quotepadding">';
    ordersHtml += '<div class="main_account_quotenumber">Quote ID : <strong>' + order.name + '</strong></div>';
    ordersHtml += '<span class="main_account_quotedate"><time datetime="' + order.created_at + '">' + formattedDate + '</time></span>';

    if (order.order_invoice_file) {
        order_invoicefile = order.order_invoice_file;
        ordersHtml += '<div class="main_account-invoicefile">';
        ordersHtml += '<a href="' + order_invoicefile.replace("https://cdn.shopify.com/s/files/1/0670/0443/2631/files", '//zvfnuz-gm.myshopify.com/cdn/shop/files') + '" class="main_account_invoice_download" download="Invoice_file">';
        ordersHtml += 'Invoice</a></div>';
    }

    ordersHtml += '</div>';
    ordersHtml += '<div class="main_account-righthead-quotecontent">';
    ordersHtml += '<div class="main_account-quotetotal main_account_quotepadding">Total : <strong>' + currency_symbol + getEuros(order.total_price) + '</strong></div>';
    ordersHtml += '<div class="main_account-managequote main_account_quotepadding"><a href="' + order.invoice_url + '" class="btn btn--primary placeorder_btn">Place Order</a>';

    if (order_tag.includes("Won") || order_tag.includes("won")) {
        ordersHtml += '<div class="order-complete-button">Order Completed</div>';
    }

    ordersHtml += '<a href="javascript:void(0);" class="btn btn--primary resubmitted_btn" data-draft-order-id="' + order.id + '">Re-submit</a>';
    ordersHtml += '<div class="quote_order_cancle" data-draft-order-id="' + order.id + '"></div><span class="main_account-managequote-arrow"></span>';
    ordersHtml += '</div></div></div>';

    ordersHtml += '<div class="main_account_quotecontent-body">';

    // form condition
    if (!order_tag.includes("Submitted") || !order_tag.includes("submitted") && !order_tag.includes("Unissued") || !order_tag.includes("unissued") && !order_tag.includes("Accepted") || !order_tag.includes("accepted") && !order_tag.includes("Issued") || !order_tag.includes("issued") && !order_tag.includes("Open") || !order_tag.includes("open")) {
        ordersHtml += '<form id="quoteproduct-listform" class="hidden-customerinfo">';
        ordersHtml += '<input type="hidden" name="tags" value="Unissued"><input type="hidden" class="form-control" name="customerName" value="' + customer_firstname + '">';
        ordersHtml += '<input type="hidden" class="form-control" name="customerEmail" value="' + customer_email + '"><input type="hidden" class="form-control" name="customerCountry" value="' + customer_country + '"><input type="hidden" class="form-control" name="customerZipcode" value="' + customer_zipcode + '">';
        ordersHtml += '<input type="hidden" class="form-control" name="customerPhoneNumber" value="' + customer_phone + '"><input type="hidden" class="form-control" name="days" value=""><input type="hidden" class="form-control" name="customerNotes" value="">';
    } else {
        if (quote_daysDiff >= 90) {
            ordersHtml += '<input type="hidden" name="tags" value="Unissued"><form id="quoteproduct-listform" class="hidden-customerinfo">';
            ordersHtml += '<input type="hidden" class="form-control" name="customerName" value="' + customer_firstname + '">';
            ordersHtml += '<input type="hidden" class="form-control" name="customerEmail" value="' + customer_email + '"><input type="hidden" class="form-control" name="customerCountry" value="' + customer_country + '"><input type="hidden" class="form-control" name="customerZipcode" value="' + customer_zipcode + '">';
            ordersHtml += '<input type="hidden" class="form-control" name="customerPhoneNumber" value="' + customer_phone + '"><input type="hidden" class="form-control" name="days" value=""><input type="hidden" class="form-control" name="customerNotes" value="">';
        } else {
            ordersHtml += '';
        }
    }

    order.line_items.forEach(function (item, index) {
        ordersHtml += '<div class="main_account_quoteitem"><input type="hidden" name="quotealltag" value="' + order.tags + '" />';

        if (quote_daysDiff < 90) {
            if (order_tag.indexOf('Submitted') != -1 || order_tag.indexOf('Submitted') != -1 || order_tag.indexOf('Unissued') != -1 || order_tag.indexOf('unissued') != -1) {
                ordersHtml += '<input type="hidden" name="quotedraftid" value="' + order.name + '"/><input type="hidden" name="quotevariant" value="' + item.variant_id + '"/><input type="hidden" name="quoteqty" value="' + item.product_quantity + '"/>';
                ordersHtml += '<input type="hidden" class="newtag" name="newtag" value="">';
            } else if (order_tag.indexOf('Accepted') != -1 || order_tag.indexOf('accepted') != -1 || order_tag.indexOf('completed') != -1 || order_tag.indexOf('Issued') != -1 || order_tag.indexOf('issued') != -1 || order_tag.indexOf('Open') != -1 || order_tag.indexOf('open') != -1) {
                ordersHtml += '<input type="hidden" name="quotedraftid" value="' + order.name + '"/><input type="hidden" name="quotevariant" value="' + item.variant_id + '"/><input type="hidden" name="quoteqty" value="' + item.product_quantity + '"/>';
                ordersHtml += '<input type="hidden" class="newtag" name="newtag" value="">';
            } else {
                ordersHtml += `
                <input type="hidden" name="products[${index}][variantId]" value="${item.variant_id}" />
                <input type="hidden" name="products[${index}][quantity]" value="${item.product_quantity}" />
                <input type="hidden" name="products[${index}][productId]" value="${item.product_id}" />
                <input type="hidden" name="products[${index}][handle]" value="${item.product_handle}" />
                <input type="hidden" name="products[${index}][title]" value="${item.product_title}" />
                <input type="hidden" name="products[${index}][price]" value="${item.product_price}" />
                `;
            }
        } else {
            ordersHtml += `
                <input type="hidden" name="products[${index}][variantId]" value="${item.variant_id}" />
                <input type="hidden" name="products[${index}][quantity]" value="${item.product_quantity}" />
                <input type="hidden" name="products[${index}][productId]" value="${item.product_id}" />
                <input type="hidden" name="products[${index}][handle]" value="${item.product_handle}" />
                <input type="hidden" name="products[${index}][title]" value="${item.product_title}" />
                <input type="hidden" name="products[${index}][price]" value="${item.product_price}" />
                `;
        }
        // ordersHtml += '<input type="hidden" name="p_handle[]" value="' + item.product_handle + '"/><input type="hidden" name="p_id[]" value="' + item.product_id + '"/>';
        ordersHtml += '<div class="main_account_quoteitem-img-con-wrap">';
        ordersHtml += '<div class="main_account_quoteitem-imgwrap">';
        if (item.product_image_src == undefined || item.product_image_src == null || item.product_image_src == '') {
            ordersHtml += 'No Image';
        } else {
            ordersHtml += '<img src="' + item.product_image_src + '" alt="Quote item" width="" height="">';
        } ordersHtml += '</div>';
        ordersHtml += '<div class="main_account_quoteitem-titlecontent">';
        ordersHtml += '<div class="main_account_quoteitem-title"><a href="/products/' + item.product_handle + '" class="main_account_quoteitem-titlelink">' + item.product_title + '</a></div>';
        ordersHtml += '<div class="main_account_quoteitem-mobilecontent">';
        ordersHtml += '<div class="main_account__quoteitem-qtycontent"><span class="main_account__quoteitem-qty">Qty : <strong>' + item.product_quantity + '</strong></span></div>';
        ordersHtml += '<div class="main_account__quoteitem-pricecontent"><span class="main_account__quoteitem-price">Quoted Price : <strong>' + currency_symbol + getEuros(item.product_price) + '</strong></span></div>';
        ordersHtml += '</div>';
        ordersHtml += '</div>';
        ordersHtml += '</div>';
        ordersHtml += '<div class="main_account_quoteitem-content">';
        ordersHtml += '<div class="main_account__quoteitem-qtycontent"><span class="main_account__quoteitem-qty">Qty : <strong>' + item.product_quantity + '</strong></span></div>';
        ordersHtml += '<div class="main_account__quoteitem-pricecontent"><span class="main_account__quoteitem-price">Quoted Price : <strong>' + currency_symbol + getEuros(item.product_price) + '</strong></span></div>';
        ordersHtml += '</div>';
        ordersHtml += '</div>';

    });
    if (!order_tag.includes("Submitted") || !order_tag.includes("Submitted") && !order_tag.includes("Unissued") || !order_tag.includes("unissued") && !order_tag.includes("Accepted") || !order_tag.includes("accepted") && !order_tag.includes("Issued") || !order_tag.includes("issued") && !order_tag.includes("Open") || !order_tag.includes("open")) {
        ordersHtml += '</form>';
    } else {
        if (quote_daysDiff >= 90) {
            ordersHtml += '</form>';
        } else {
            ordersHtml += '';
        }
    }
    ordersHtml += '<div class="main_account__quoteitem-chatnote">';
    ordersHtml += '<div class="main_account__quoteitem-chatwrap block__chat-shopifyinbox"><span class="main_account__quoteitem-chattxt">Request Assistance with Quote</span></div>';
    if (order.note != '') {
        ordersHtml += '<div class="main_account__quoteitem-quotenote">Order Notes : <span class="main_account__quoteitem-notetxt">' + order.note + '</span></div>';
    } else { }
    ordersHtml += '</div>';
    ordersHtml += '</div>';
    ordersHtml += '</div>';

    document.querySelector('.quote-content-loader .loading__spinner')?.classList.add('hidden');

    let filterWrap = document.querySelector('.block__quote-order-filterwrap');
    if (filterWrap) filterWrap.style.display = 'flex';

    function showContainer(selector, html) {
        let container = document.querySelector(selector);
        if (!container) return;

        let parent = container.closest('.block__quote-ordercontentwrap');
        if (parent) {
            parent.classList.add('available-quote');
            parent.style.display = 'block';
        }

        container.insertAdjacentHTML('beforeend', html);
    }

    if (quote_daysDiff < 90) {
        if (order_tag.indexOf('Won') == -1) {
            if (
                order_tag.indexOf('Submitted') != -1 ||
                order_tag.indexOf('submitted') != -1 ||
                order_tag.indexOf('Unissued') != -1 ||
                order_tag.indexOf('unissued') != -1
            ) {
                showContainer('#quote-submitted-container', ordersHtml);
            } else if (
                order_tag.indexOf('Accepted') != -1 ||
                order_tag.indexOf('accepted') != -1 ||
                order_tag.indexOf('completed') != -1 ||
                order_tag.indexOf('Issued') != -1 ||
                order_tag.indexOf('issued') != -1 ||
                order_tag.indexOf('Open') != -1 ||
                order_tag.indexOf('open') != -1
            ) {
                showContainer('#quote-activated-container', ordersHtml);

                let first = document.querySelector('#quote-activated-container .main_account_quotehistory');
                if (first) first.classList.add('is-open');

                setTimeout(function () {
                    document.querySelectorAll('#quote-activated-container .main_account_quotehistory')
                        .forEach(el => el.style.display = 'block');
                }, 3 * 60 * 1000);

            } else {
                showContainer('#quote-closed-container', ordersHtml);
            }
        } else {
            showContainer('#quote-closed-container', ordersHtml);
        }
    } else {
        showContainer('#quote-closed-container', ordersHtml);
    }
}

// item arrow click
document.addEventListener('click', function (e) {
    const target = e.target.closest('.main_account-managequote .main_account-managequote-arrow');
    if (target) {
        e.preventDefault();
        const parent = target.closest('.main_account_quotehistory');
        if (parent) {
            parent.classList.toggle('is-open');
        }
    }
});


// Toggle filter list
const filterTxt = document.querySelector('.block__quote-filtertxt');
const filterList = document.querySelector('.block__quote-filterlist');

if (filterTxt && filterList) {
    filterTxt.addEventListener('click', function () {
        filterList.style.display =
            filterList.style.display === 'none' || filterList.style.display === ''
                ? 'block'
                : 'none';
    });
}

// Filter list click
const allOptions = document.querySelectorAll('.block__quote-filterlist .block__quote-filter-item');

if (filterList) {
    filterList.addEventListener('click', function (e) {
        const item = e.target.closest('.block__quote-filter-item');
        if (!item) return;
        const selectedValue = item.getAttribute('data-value');
        allOptions.forEach(opt => opt.classList.remove('selected'));
        item.classList.add('selected');

        // Update text
        const filterTextSpan = document.querySelector('.block__quote-filtertxt .filter-txt');
        if (filterTextSpan) {
            filterTextSpan.innerHTML = item.innerHTML;
        }

        // Hide dropdown
        filterList.style.display = 'none';
        const allQuotes = document.querySelectorAll('.block__quote-ordercontentwrap');
        if (selectedValue === 'all-quotes') {
            document.querySelectorAll('.block__quote-ordercontentwrap.available-quote')
                .forEach(el => el.style.display = 'block');
        } else {
            allQuotes.forEach(el => {
                const value = el.getAttribute('data-quotefilter');

                if (value !== selectedValue) {
                    el.style.display = 'none';
                } else {
                    const hasHistory = el.querySelector('.main_account_quotehistory');
                    if (hasHistory) {
                        el.style.display = 'block';
                    }
                }
            });
        }
    });
}

// Re-submit button
document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.resubmitted_btn');
    if (!btn) return;

    e.preventDefault();
    btn.classList.add('btn-loading');

    const parent = btn.closest('.main_account_quotehistory');
    const form = parent ? parent.querySelector('#quoteproduct-listform') : null;
    if (!form) return;

    const formData = new FormData(form);
    const params = new URLSearchParams();

    formData.forEach((value, key) => {
        params.append(key, value);
    });

    async function moveAlong() {
        try {
            const response = await fetch('https://dtfrvnbitwxyk.cloudfront.net/draftorder.php', {
                method: 'POST',
                body: params
            });

            form.classList.add('quote-products-hide');
            form.style.display = 'none';

            const mainHeading = document.querySelector('.quotedrawer-product-mainheading');
            if (mainHeading) mainHeading.style.display = 'none';

            const submittedContent = document.querySelector('.quotedrawer-product-submittedcontent');
            if (submittedContent) {
                submittedContent.classList.add('quote-submit-active');
                submittedContent.style.display = 'block';
            }

            localStorage.removeItem("quoteProduct");
            window.location.reload();

        } catch (error) {
            console.error('Request failed:', error);
        }
    }
    moveAlong();
});

// Quote close btn
document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.quote_order_cancle');
    if (!btn) return;

    e.preventDefault();
    btn.classList.add('cancle-loading');

    const quoteDraftOrderId = btn.getAttribute('data-draft-order-id');

    const parent = btn.closest('.main_account_quotehistory');
    let cancleQuoteTags = '';

    if (parent) {
        const input = parent.querySelector('.main_account_quoteitem input[name="quotealltag"]');
        if (input) {
            cancleQuoteTags = input.value;
        }
    }

    cancleQuoteTags = cancleQuoteTags.replace(/Issued|Open|Submitted|Unissued|Accepted|issued|open|submitted|unissued|accepted/g, '').trim();
    cancleQuoteTags = cancleQuoteTags.replace(/,\s*,/g, ', ').replace(/^\s*,|,\s*$/g, '').trim();
    cancleQuoteTags = cancleQuoteTags + ", Closed";

    try {
        const response = await fetch('https://dtfrvnbitwxyk.cloudfront.net/delete_draft_order.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                draft_order_id: quoteDraftOrderId,
                newtag: cancleQuoteTags
            })
        });

        const text = await response.text();
        const result = JSON.parse(text);

        if (result.status === 'success') {
            btn.classList.remove('cancle-loading');
            window.location.reload();
        } else {
            btn.classList.remove('cancle-loading');
        }

    } catch (error) {
        console.error('Request failed:', error);
        btn.classList.remove('cancle-loading');
    }
});